import axios from "axios";
import { toast } from "react-toastify";
import companyAuthHeader from "./companyAuthHeader";
import authHeader from "./auth-header";

export const getAllGodowns = (filters) => {
  return new Promise((resolve, reject) => {
    const params = new URLSearchParams();
    
    if (filters) {
      Object.keys(filters).forEach(key => {
        if (filters[key] !== null && filters[key] !== undefined && filters[key] !== '') {
          params.append(key, filters[key]);
        }
      });
    }
    
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/godown?${params.toString()}`, {
        headers: companyAuthHeader(),
      })
      .then((res) => {
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const getAvailableGodowns = (filters) => {
  const params = new URLSearchParams();

  Object.entries(filters || {}).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== "") {
      params.append(key, value);
    }
  });

  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/godown/select?${params.toString()}`, {
      headers: authHeader(),
    })
    .then((res) => res.data.data)
    .catch((err) => {
      if (err?.response?.data?.msg) toast.error(err.response.data.msg);
      throw err;
    });
};

export const getGodown = (id) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/godown/${id}`, {
        headers: companyAuthHeader(),
      })
      .then((res) => {
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const createGodown = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${process.env.REACT_APP_BASE_URL}/godown`, data, {
        headers: companyAuthHeader(),
      })
      .then((res) => {
        toast.success(res.data.msg);
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const updateGodown = (data, id) => {
  return new Promise((resolve, reject) => {
    axios
      .put(`${process.env.REACT_APP_BASE_URL}/godown/${id}`, data, {
        headers: companyAuthHeader(),
      })
      .then((res) => {
        toast.success(res.data.msg);
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const deleteGodown = (id) => {
  return new Promise((resolve, reject) => {
    axios
      .delete(`${process.env.REACT_APP_BASE_URL}/godown/${id}`, {
        headers: companyAuthHeader(),
      })
      .then((res) => {
        toast.success(res.data.msg);
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};
